import { createContext, useContext, useState, ReactNode } from "react";

interface VisitNotePanelContextType {
  isPanelExpanded: boolean;
  setIsPanelExpanded: (value: boolean) => void;
}

const VisitNotePanelContext = createContext<VisitNotePanelContextType>({
  isPanelExpanded: false,
  setIsPanelExpanded: () => {},
});

export const VisitNotePanelProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [isPanelExpanded, setIsPanelExpanded] = useState(false);

  return (
    <VisitNotePanelContext.Provider
      value={{ isPanelExpanded, setIsPanelExpanded }}
    >
      {children}
    </VisitNotePanelContext.Provider>
  );
};

export const useVisitNotePanel = () => useContext(VisitNotePanelContext);
